import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { AppState } from '@redux/store'

export interface CancelClaimState {
  showCancelModal: boolean
  showNullifyModal: boolean
  showCancelQuoteModal: boolean
  isLastNullify: boolean
}

const initialState = {
  showCancelModal: false,
  showNullifyModal: false,
  showCancelQuoteModal: false,
  isLastNullify: false
} as CancelClaimState

const REDUCER_PATH = 'cancelClaim'

export const cancelClaimSlice = createSlice({
  name: REDUCER_PATH,
  initialState: initialState,
  reducers: {
    showCancelClaimModal(state) {
      state.showCancelModal = true
    },
    hideCancelClaimModal(state) {
      state.showCancelModal = false
    },
    showNullifyClaimModal(state, action: PayloadAction<boolean>) {
      state.showNullifyModal = true
      state.isLastNullify = action.payload
    },
    hideNullifyClaimModal(state) {
      state.showNullifyModal = false
      state.isLastNullify = false
    },
    showCancelQuoteModal(state) {
      state.showCancelQuoteModal = true
    },
    hideCancelQuoteModal(state) {
      state.showCancelQuoteModal = false
    },
    resetCancelClaimInitialState(state) {
      return initialState
    }
  },
})

export const {
  showCancelClaimModal,
  hideCancelClaimModal,
  showNullifyClaimModal,
  hideNullifyClaimModal,
  showCancelQuoteModal,
  hideCancelQuoteModal,
  resetCancelClaimInitialState,
} = cancelClaimSlice.actions

export const showCancelClaimSelector = (state: AppState): boolean => state.cancelClaim.showCancelModal
export const showNullifyClaimSelector = (state: AppState): boolean => state.cancelClaim.showNullifyModal
export const isLastNullifySelector = (state: AppState): boolean => state.cancelClaim.isLastNullify
export const showCancelQuoteSelector = (state: AppState): boolean => state.cancelClaim.showCancelQuoteModal
